<template>
  <div class="h-full bg-documentGray">
    <Popup :showPopup="showPopup"></Popup>
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      :hideCategory="false"
      staticMode="true"
    >
    </TopAppBar>
    <div
      class="d-flex flex-column bg-documentGray"
      :class="isScroll ? 'h-full' : ''"
    >
      <TopAppBarDrawer></TopAppBarDrawer>
      <main class="main-wrapper flex-grow-1">
        <div
          class="view-details-header bg-primary position-relative min-h-auto"
        >
          <div class="header-image">
            <img src="/img/header-banner-new.png" alt="" />
          </div>
          <div
            class="container container--main-header position-relative pdt-50 pdb-50 pdl-16 pdr-16"
          >
            <div
              class="t-headline3 t-color-whiteHigh t-center t-line-h-39 font-b"
            >
              Please select a tag #
            </div>
            <div class="t-body1 t-center t-color-whiteHigh mgt-8 font-r">
              What interests you?
            </div>

            <!-- 태그 종류 리스트 -->
            <div
              class="mgt-22 mgb-18 mdc-chip-set banner--chip chip--outlined main-header justify-content-center"
              role="grid"
              v-if="popularTag && popularTag.length > 0"
            >
              <div
                class="mdc-chip pdl-20 pdr-20 cursor-pointer"
                tabindex="0"
                role="row"
                v-for="(tag, index) in popularTag"
                :key="index"
                :class="selectedTags.includes(tag.id) ? 'selected' : ''"
                @click="selectedTagFun(tag, selectedTags)"
                @keypress="selectedTagFun(tag, selectedTags)"
              >
                <div class="mdc-chip__ripple"></div>
                <span role="gridcell">
                  <span class="mdc-chip__text t-body4 font-r">
                    {{ tag.name }}
                  </span>
                </span>
              </div>
            </div>
            <div
              v-else
              class="mgt-22 mgb-18 mdc-chip-set banner--chip chip--outlined main-header justify-content-center"
              role="grid"
            >
              <span role="gridcell">
                <span class="mdc-chip__text t-body6 font-r t-color-whiteHigh">
                  {{ $t("30230") }}
                </span>
              </span>
            </div>

            <!-- 태그 검색 버튼 -->
            <div class="t-center">
              <button
                class="mdc-button mdc-button--raised bg-mainBtn b-radius4 w-160 mgb-2"
                v-if="tagSearchBtn"
                @click="serachResultByTag"
                @keypress="serachResultByTag"
                tabindex="0"
              >
                <span
                  class="mdc-button__label t-body2 font-r t-color-mainBtnText"
                  >{{ $t("3196") }}</span
                >
              </button>
              <button
                class="mdc-button bg-disableBtn disabled b-radius4 w-160 mgb-2"
                v-else
              >
                <span
                  class="mdc-button__label t-body2 font-r t-color-disableBtnText"
                  >{{ $t("3196") }}</span
                >
              </button>
            </div>
          </div>
        </div>
        <div class="container pdt-50">
          <div class="d-flex mobile-column">
            <UserImgProfile v-if="this.memberData" :data="this.memberData" :size="'main-l'" />

            <div class="flex-grow-1 mgl-24 mobile-mgl-0">
              <div
                class="user-head-info d-flex justify-content-between mobile-column"
              >
                <div>
                  <div class="t-headline3 font-b t-line-h-66">
                    Hello,
                    {{
                      firstName || lastName
                        ? $t("3437", { first: firstName, last: lastName })
                        : ""
                    }}
                  </div>
                  <div class="t-body6 t-color-bodyGrayA font-r mgt-8">
                    {{ this.memberDetail ? this.memberDetail.userId : null }}
                  </div>
                  <div class="d-flex user-list-info mgt-4">
                    <div class="t-body6 t-color-bodyGrayA pdr-8 mgr-8 font-r">
                      {{ memberDetail ? memberDetail.dutyName : null }}
                    </div>
                    <div class="t-body6 t-color-bodyGrayA pdr-8 mgr-8 font-r">
                      {{
                        memberDetail ? memberDetail.responsibilityName : null
                      }}
                    </div>
                  </div>
                </div>

                <!-- Dashboard 4 circle icons -->
                <DashBoardCircleIcons
                  :goToMicroLearning="goToMicroLearning"
                  :goToLearning="goToLearning"
                  :microLearning="microLearning"
                  :learning="learning"
                  :goToCompletion="goToCompletion"
                  :completion="completion"
                  :goToMyTest="goToMyTest"
                  :eaxmTest="eaxmTest"
                  :goToMySurvey="goToMySurvey"
                  :survey="survey"
                  :isSkillPath="isSkillPath"
                />
              </div>

              <!-- Dashboard Member Detail -->
              <div class="mgt-24">
                <div>
                  <span
                    v-if="memberDetail && memberDetail.level"
                    class="bg-contentRed t-color-whiteHigh pdl-8 pdr-8 pdt-2 pdb-2 t-body2 font-r d-inline-block b-radius2 mgr-4"
                    >Level
                    {{
                      memberDetail && memberDetail.level
                        ? memberDetail.level.id
                        : null
                    }}</span
                  >
                  <span
                    class="bg-headlineBlack t-color-whiteHigh pdl-8 pdr-8 pdt-2 pdb-2 t-body2 font-r d-inline-block b-radius2 mgr-4"
                    >{{
                      memberDetail && memberDetail.points.length > 0
                        ? memberDetail.points[0].amount
                        : 0
                    }}
                    P</span
                  >
                  <span
                    class="t-color-bodyGrayB pdl-4 font-r t-body3"
                    v-if="
                      pointHistry &&
                      pointHistry.length > 0 &&
                      pointHistry[0].point > 0
                    "
                    >{{ $t("3197") }}</span
                  >
                  <span
                    class="t-color-bodyGrayB pdl-4 font-r t-body3"
                    v-if="
                      pointHistry &&
                      pointHistry.length > 0 &&
                      pointHistry[0].point === 0
                    "
                    >{{ $t("3200") }} {{ $t("3200") }}</span
                  >
                  <span class="t-color-bodyGrayA pdl-4 font-m t-body2">
                    {{
                      pointHistry && pointHistry.length > 0
                        ? pointHistry[0].point
                        : null
                    }}P</span
                  >
                </div>
                <div class="mgt-28 d-flex">
                  <div
                    class="pda-3 d-flex mgr-24 mobile-mgr-16 cursor-pointer"
                    @click.prevent="$router.push('/bookmarked-lesson')"
                    @keypress.prevent="$router.push('/bookmarked-lesson')"
                    tabindex="0"
                  >
                    <img src="/img/book-outline.svg" alt="" class="w-24 h-24" />
                    <span
                      class="pdl-6 t-headline7 t-color-lectureRed font-m t-line-h-22 pdt-2"
                      >{{
                        portFolioList ? portFolioList.lessonBookmarkCount : ""
                      }}</span
                    >
                  </div>
                  <div
                    class="pda-3 d-flex mgr-24 mobile-mgr-16 cursor-pointer"
                    @click.prevent="$router.push('/bookmarked-mission')"
                    @keypress.prevent="$router.push('/bookmarked-mission')"
                    tabindex="0"
                  >
                    <img
                      src="/img/notebook-outline.svg"
                      alt=""
                      class="w-24 h-24"
                    />
                    <span
                      class="pdl-6 t-headline7 t-color-lecturePurple font-m t-line-h-22 pdt-2"
                      >{{
                        portFolioList ? portFolioList.missionBookmarkCount : ""
                      }}</span
                    >
                  </div>
                  <div
                    class="pda-3 d-flex mgr-24 mobile-mgr-16 cursor-pointer"
                    @click.prevent="$router.push('/liked-lesson')"
                    @keypress.prevent="$router.push('/liked-lesson')"
                    tabindex="0"
                  >
                    <img
                      src="/img/heart-box-outline.svg"
                      alt=""
                      class="w-24 h-24"
                    />
                    <span
                      class="pdl-6 t-headline7 t-color-lectureYellow font-m t-line-h-22 pdt-2"
                      >{{
                        portFolioList ? portFolioList.lessonLikeCount : ""
                      }}</span
                    >
                  </div>
                  <div
                    class="pda-3 d-flex mgr-24 v cursor-pointer"
                    @click.prevent="$router.push('/social-lesson')"
                    @keypress.prevent="$router.push('/social-lesson')"
                    tabindex="0"
                  >
                    <img
                      src="/img/tag-heart-outline.svg"
                      alt=""
                      class="w-24 h-24"
                    />
                    <span
                      class="pdl-6 t-headline7 t-color-lectureAqua font-m t-line-h-22 pdt-2"
                      >{{
                        portFolioList ? portFolioList.articleLikeCount : ""
                      }}</span
                    >
                  </div>
                </div>

                <!-- Dashboard Current Leanring -->
                <DashBoardCurrentLearn
                  :isSkillPath="isSkillPath"
                  :recentLearning="recentLearning"
                  :redirectToRecentLearnDetail="redirectToRecentLearnDetail"
                />
              </div>
            </div>
          </div>
          <div class="divider mgt-21"></div>
        </div>

        <div class="container main-swiper-container">
          <!-- 학습 중인 스킬 패스 -->
          <div v-if="isSkillPath">
            <div
              class="d-flex justify-content-between align-items-baseline mgt-50 mgb-16"
              v-if="recentMicroContentData"
            >
              <div class="t-color-headlineBlack t-headline10 font-b">
                {{ $t("30227") }}
              </div>
              <!-- TODO : 모두보기 -> 스킬패스 학습창으로 이동 -->
              <div
                class="t-color-secondaryBtnText t-body2 font-m cursor-pointer"
                tabindex="0"
                v-if="recentMicroContentDataLength > 0"
                @click.prevent="$router.push('/micro?status=LEARNING')"
                @keypress.prevent="$router.push('/micro?status=LEARNING')"
              >
                {{ $t("1902") }}
              </div>
            </div>
            <!-- 학습 중인 스킬 패스 Swiper -->
            <swiper
              :options="swiperOption"
              ref="mySwiper"
              class="main-swiper pdx-4"
              v-if="recentMicroContentDataLength > 0"
            >
              <swiper-slide
                class="swiper-slide"
                v-for="(ctDatat, i) of recentMicroContentData"
                :key="i"
              >
                <div
                  class="mdc-card cursor-pointer"
                  @click="redirectToLearnDetail(ctDatat.id, 'MICRO')"
                  @keypress="redirectToLearnDetail(ctDatat.id, 'MICRO')"
                  tabindex="0"
                >
                  <div class="mdc-card__primary-action1">
                    <div class="position-relative" v-if="ctDatat.thumbnail">
                      <img
                        :src="ctDatat.thumbnail"
                        v-if="ctDatat.thumbnail"
                        :alt="ctDatat.name"
                      />
                      <!-- <img src="/img/slider-placeholder.svg" v-else alt=""> -->

                      <div class="mdc-chip-set swiper-chip" role="grid">
                        <div class="mdc-chip h-28 t-line-h-initial" role="row">
                          <div class="mdc-chip__ripple"></div>
                          <span role="gridcell">
                            <span
                              role="button"
                              class="mdc-chip__primary-action"
                            >
                              <span
                                class="mdc-chip__text t-body3 pdt-2 t-color-white"
                                >{{
                                  $t("1908", { str: ctDatat.lessonCount })
                                }}</span
                              >
                            </span>
                          </span>
                        </div>
                      </div>
                      <div
                        class="home-progressbar"
                        :style="`width:${ctDatat.progressRate}%;`"
                      ></div>
                    </div>
                    <div class="mgt-24">
                      <div
                        class="t-headline7 pdl-24 pdr-24 font-m t-line-h-30 t-line-2"
                      >
                        {{ ctDatat ? ctDatat.name : "" }}
                      </div>
                    </div>
                    <div class="mgt-16">
                      <div
                        class="t-body6 pdl-24 pdr-16 t-color-bodyGrayA font-r"
                        v-if="!ctDatat.thumbnail"
                      >
                        {{ $t("1908", { str: ctDatat.lessonCount }) }}
                      </div>
                      <div
                        class="t-body6 pdl-24 pdr-16 t-color-bodyGrayA font-r"
                        v-for="(level, index2) of ctDatat.levels"
                        :key="index2"
                      >
                        {{ level.text }}
                      </div>
                    </div>
                    <div class="mgt-2 pdl-24 mgb-22">
                      <span class="font-r t-color-headlineBlack t-body6 pdr-4"
                        >by </span
                      ><span class="font-r t-color-headlineBlack t-body6">
                        {{
                          ctDatat.teacher
                            ? $t("3437", {
                                first: ctDatat.teacher.name.first,
                                last: ctDatat.teacher.name.last,
                              })
                            : ""
                        }}
                      </span>
                    </div>
                    <div
                      class="d-flex align-items-baseline pdl-24 pdb-24 pdr-24"
                    >
                      <div
                        class="t-color-headlineBlack t-headline3 pdr-2 t-line-h-44 font-b"
                      >
                        {{ ctDatat.progressRate }}
                      </div>
                      <div class="t-subtitle1 t-color-headlineBlack font-b">
                        %
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-button-prev custom-nav" slot="button-prev">
                <i class="material-icons t-color-iconActive rtl-support"
                  >arrow_back</i
                >
              </div>
              <div class="swiper-button-next custom-nav" slot="button-next">
                <i class="material-icons t-color-iconActive rtl-support"
                  >arrow_forward</i
                >
              </div>
            </swiper>
            <!-- 학습 중인 스킬 패스 빈 배열 -->
            <div v-else class="pdt-42 pdb-42">
              <div
                class="t-color-bodyGrayB font-18 d-flex justify-content-center"
              >
                {{ $t("3206") }}
              </div>
              <div
                class="t-color-bodyGrayB font-18 d-flex justify-content-center"
              >
                {{ $t("3207") }}
              </div>
            </div>
          </div>

          <!-- 학습 중인 온라인 클래스  -->
          <div
            class="d-flex justify-content-between align-items-baseline mgt-50 mgb-16"
            v-if="recentContentData"
          >
            <div class="t-color-headlineBlack t-headline10 font-b">
              {{ $t("30228") }}
            </div>
            <div
              class="t-color-secondaryBtnText t-body2 font-m cursor-pointer"
              tabindex="0"
              v-if="recentContentLength > 0"
              @click.prevent="$router.push('/learn?status=LEARNING')"
              @keypress.prevent="$router.push('/learn?status=LEARNING')"
            >
              {{ $t("1902") }}
            </div>
          </div>
          <swiper
            :options="swiperOption"
            ref="mySwiper"
            class="main-swiper pdx-4"
            v-if="recentContentLength > 0"
          >
            <swiper-slide
              class="swiper-slide"
              v-for="(ctDatat, i) of recentContentData"
              :key="i"
            >
              <div
                class="mdc-card cursor-pointer"
                @click="redirectToLearnDetail(ctDatat.id)"
                @keypress="redirectToLearnDetail(ctDatat.id)"
                tabindex="0"
              >
                <div class="mdc-card__primary-action1">
                  <div class="position-relative" v-if="ctDatat.thumbnail">
                    <img
                      :src="ctDatat.thumbnail"
                      v-if="ctDatat.thumbnail"
                      :alt="ctDatat.name"
                    />
                    <!-- <img src="/img/slider-placeholder.svg" v-else alt=""> -->

                    <div class="mdc-chip-set swiper-chip" role="grid">
                      <div class="mdc-chip h-28 t-line-h-initial" role="row">
                        <div class="mdc-chip__ripple"></div>
                        <span role="gridcell">
                          <span role="button" class="mdc-chip__primary-action">
                            <span
                              class="mdc-chip__text t-body3 pdt-2 t-color-white"
                              >{{
                                $t("1908", { str: ctDatat.lessonCount })
                              }}</span
                            >
                          </span>
                        </span>
                      </div>
                    </div>
                    <div
                      class="home-progressbar"
                      :style="`width:${ctDatat.progressRate}%;`"
                    ></div>
                  </div>
                  <div class="mgt-24">
                    <div
                      class="t-headline7 pdl-24 pdr-24 font-m t-line-h-30 t-line-2"
                    >
                      {{ ctDatat ? ctDatat.name : "" }}
                    </div>
                  </div>
                  <div class="mgt-16">
                    <div
                      class="t-body6 pdl-24 pdr-16 t-color-bodyGrayA font-r"
                      v-if="!ctDatat.thumbnail"
                    >
                      {{ $t("1908", { str: ctDatat.lessonCount }) }}
                    </div>
                    <div
                      class="t-body6 pdl-24 pdr-16 t-color-bodyGrayA font-r"
                      v-for="(level, index2) of ctDatat.levels"
                      :key="index2"
                    >
                      {{ level.text }}
                    </div>
                  </div>
                  <div class="mgt-2 pdl-24 mgb-22">
                    <span class="font-r t-color-headlineBlack t-body6 pdr-4"
                      >by </span
                    ><span class="font-r t-color-headlineBlack t-body6">
                      {{
                        ctDatat.teacher
                          ? $t("3437", {
                              first: ctDatat.teacher.name.first,
                              last: ctDatat.teacher.name.last,
                            })
                          : ""
                      }}
                    </span>
                  </div>
                  <div class="d-flex align-items-baseline pdl-24 pdb-24 pdr-24">
                    <div
                      class="t-color-headlineBlack t-headline3 pdr-2 t-line-h-44 font-b"
                    >
                      {{ ctDatat.progressRate }}
                    </div>
                    <div class="t-subtitle1 t-color-headlineBlack font-b">
                      %
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
            <div class="swiper-button-prev custom-nav" slot="button-prev">
              <i class="material-icons t-color-iconActive rtl-support"
                >arrow_back</i
              >
            </div>
            <div class="swiper-button-next custom-nav" slot="button-next">
              <i class="material-icons t-color-iconActive rtl-support"
                >arrow_forward</i
              >
            </div>
          </swiper>
          <!-- 학습 중인 온라인 클래스 빈 배열 -->
          <div v-else class="pdt-42 pdb-42">
            <div
              class="t-color-bodyGrayB font-18 d-flex justify-content-center"
            >
              {{ $t("3206") }}
            </div>
            <div
              class="t-color-bodyGrayB font-18 d-flex justify-content-center"
            >
              {{ $t("3207") }}
            </div>
          </div>

          <!-- 추천 강의 -->
          <div
            class="d-flex justify-content-between align-items-baseline mgt-50 mgb-16"
            v-if="recommendedList && recommendedList.length > 0"
          >
            <div class="t-color-headlineBlack t-headline10 font-b">
              {{ $t("1904") }}
            </div>
            <div
              class="t-color-secondaryBtnText t-body2 font-m cursor-pointer"
              tabindex="0"
              v-if="recommendedList && recommendedListLength > 0"
              @click.prevent="$router.push('/degree?type=ListRecommened')"
              @keypress.prevent="$router.push('/degree?type=ListRecommened')"
            >
              {{ $t("1905") }}
            </div>
          </div>

          <swiper
            :options="swiperOption"
            ref="mySwiper"
            class="main-swiper pdx-4"
            v-if="recommendedList && recommendedList.length > 0"
          >
            <swiper-slide
              class="mgb-6 swiper-slide wiperSlideWrapper bg-white"
              v-for="(recoList, k) of recommendedList"
              track-by="id"
              :key="k"
            >
              <div
                class="mdc-card cursor-pointer"
                @click="redirectToCourseDetail(recoList.id)"
                @keypress="redirectToCourseDetail(recoList.id)"
                tabindex="0"
              >
                <div class="mdc-card__primary-action1">
                  <div class="position-relative" v-if="recoList.thumbnail">
                    <img
                      :src="recoList.thumbnail"
                      :alt="recoList.name"
                      v-if="recoList.thumbnail"
                    />
                    <img
                      src="/img/slider-placeholder.svg"
                      v-else
                      :alt="recoList.name"
                    />

                    <div class="mdc-chip-set swiper-chip" role="grid">
                      <div class="mdc-chip h-28 t-line-h-initial" role="row">
                        <div class="mdc-chip__ripple"></div>
                        <span role="gridcell">
                          <span role="button" class="mdc-chip__primary-action">
                            <span
                              class="mdc-chip__text t-body3 pdt-2 t-color-white"
                              >{{
                                $t("1908", { str: recoList.lessonCount })
                              }}</span
                            >
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="mgt-24">
                    <div class="t-headline7 pdl-24 pdr-24 font-m t-line-2">
                      {{ recoList ? recoList.name : "" }}
                    </div>
                  </div>
                  <div class="mgt-16">
                    <div
                      class="t-body6 pdl-24 pdr-16 t-color-bodyGrayA font-r"
                      v-if="!recoList.thumbnail"
                    >
                      {{ $t("1908", { str: recoList.lessonCount }) }}
                    </div>
                    <div
                      class="t-body6 pdl-24 pdr-16 t-color-bodyGrayA font-r"
                      v-for="(level, index4) of recoList.levels"
                      :key="index4"
                    >
                      {{ level.text }}
                    </div>
                  </div>
                  <div class="mgt-2 pdl-24 mgb-16">
                    <span class="font-r t-color-headlineBlack t-body6 pdr-4"
                      >by </span
                    ><span class="font-r t-color-headlineBlack t-body6">{{
                      recoList.teacher
                        ? $t("3437", {
                            first: recoList.teacher.name.first,
                            last: recoList.teacher.name.last,
                          })
                        : ""
                    }}</span>
                  </div>
                  <div
                    class="d-flex align-items-baseline pdl-24 pdb-24 pdr-24"
                    v-if="recoList.goods && recoList.goods.paymentPrice > 0"
                  >
                    <div class="t-color-headlineBlack t-body-6 pdr-4">
                      {{ recoList.goods.currency.key || "USD" }}
                    </div>
                    <div
                      class="t-color-headlineBlack t-headline10 font-b pdr-8"
                    >
                      {{ $n(recoList.goods.paymentPrice) }}
                    </div>
                    <div
                      class="t-body1 t-color-bodyGrayB t-line-through-red"
                      v-if="recoList.goods.paymentPrice < recoList.goods.price"
                    >
                      {{ $n(recoList.goods.price) }}
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-baseline pdl-24 pdb-24 pdr-24"
                    v-if="recoList.goods && !recoList.goods.paymentPrice"
                  >
                    <div
                      class="t-color-headlineBlack t-headline10 font-b pdr-8"
                    >
                      {{ $t("872") }}
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>

            <div class="swiper-button-prev custom-nav" slot="button-prev">
              <i class="material-icons t-color-iconActive rtl-support"
                >arrow_back</i
              >
            </div>
            <div class="swiper-button-next custom-nav" slot="button-next">
              <i class="material-icons t-color-iconActive rtl-support"
                >arrow_forward</i
              >
            </div>
          </swiper>

          <div class="pdb-50" v-if="baordIdentifier">
            <div
              class="d-flex justify-content-between align-items-baseline mgt-50 mgb-16"
            >
              <div class="t-color-headlineBlack t-headline10 font-b">
                {{ boardName }}
              </div>
              <div
                v-if="!isNoData"
                class="t-color-secondaryBtnText t-body2 font-m cursor-pointer"
                tabindex="0"
                @click="moveToBoardList(boardDetail)"
                @keypress="moveToBoardList(boardDetail)"
              >
                {{ $t("1907") }}
              </div>
            </div>
            <!-- no data community starts -->
            <div class="pdt-50 pdb-50" v-if="isNoData === true">
              <div
                class="d-flex align-items-center justify-content-center pdt-4 pdb-4 t-subtitle6 t-line-h-26 t-color-bodyGrayB font-r"
              >
                {{ $t("3442") }}
              </div>
            </div>
            <!-- no data community ends here -->
            <div class="mdc-card" v-if="isNoData === false">
              <div
                v-for="(board, index) in listData"
                :key="index"
                @click="moveToDetail(board.id)"
                @keypress="moveToDetail(board.id)"
                tabindex="0"
              >
                <div class="pda-24">
                  <div
                    class="t-subtitle6 l-spacing54 t-line-h-22 t-color-headlineBlack t-line-1 font-r"
                  >
                    {{ board.contents ? board.contents.subject : "" }}
                  </div>
                  <div
                    class="mgt-8 d-flex align-items-baseline justify-content-between"
                  >
                    <div
                      class="t-body6 l-spacing45 t-line-h-22 t-color-headlineBlack font-r"
                      v-if="
                        board.auditor &&
                        board.auditor.register &&
                        board.auditor.register &&
                        board.auditor.register.name
                      "
                    >
                      {{
                        board.auditor.register.name
                          ? $t("3437", {
                              first: board.auditor.register.name.first,
                              last: board.auditor.register.name.last,
                            })
                          : ""
                      }}
                    </div>
                    <div
                      class="t-body6 t-line-h-22 t-color-bodyGrayA font-r"
                      v-if="
                        board.auditor &&
                        board.auditor.register &&
                        board.auditor.register.time
                      "
                    >
                      {{ $moment(board.auditor.register.time).format("L") }}
                    </div>
                  </div>
                </div>
                <div
                  :class="index === listData.length - 1 ? '' : 'divider'"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="mgt-40"></div> -->
      </main>
    </div>
  </div>
</template>


<script>
import TopAppBar from "@/components/TopAppBar.vue";
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";

import { topAppBarMixin } from "../../mixins/topAppBar.js";
import mainApi from "@/api/mainApi.js";
import campaignApi from "@/api/campaignApi.js";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import "@material/mwc-linear-progress";
import { mapState } from "vuex";
import portfolioApi from "@/api/portfolioApi";
import learnApi from "@/api/learnApi.js";
import microLearnApi from "@/api/microLearnApi.js";
import examApi from "@/api/examApi.js";
import surveyApi from "@/api/surveyApi.js";
import pointApi from "@/api/pointApi.js";
import boardApi from "@/api/boardApi.js";
import Popup from "../popup/Popup.vue";
import DashBoardCircleIcons from "./DashBoardCircleIcons.vue";
import DashBoardCurrentLearn from "./DashBoardCurrentLearn.vue";
import { storageConstants } from "@/utils/enum/StorageConstants";
import i18nApi from "@/api/i18nApi";
import localStorageUtil from "@/utils/localStorageUtil.js";

export default {
  name: "Main",
  components: {
    swiper,
    swiperSlide,
    TopAppBar,
    TopAppBarDrawer,
    Popup,
    DashBoardCircleIcons,
    DashBoardCurrentLearn,
    UserImgProfile: () => import("@/components/common/checkUser/UserImgProfile.vue"),
},
  data() {
    return {
      pointHistry: null,
      microLearning: 0,
      learning: 0,
      completion: 0,
      eaxmTest: 0,
      survey: 0,
      portFolioList: null,
      categoryData: null,
      memberData: null,
      firstName: null,
      lastName: null,
      fullName: null,
      profileImage: null,
      recentData: null,
      newVideoTalkData: null,
      recommendedList: null,
      recommendedListLength: 0,
      recentContentData: null,
      recentContentLength: 0,
      recentMicroContentData: null,
      recentMicroContentDataLength: 0,
      recentLearning: null,
      recentSubjectImage: null,
      recentSubject: null,
      campaignData: null,
      isCompaignImage: false,
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 20,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        translate: 0,
        autoHeight: false,
      },
      compaignImage: null,
      dynamicLinkImage: null,
      linearProgress: true,
      popularTag: null,
      selectedTags: [],
      selectedTagsName: [],
      tagSearchBtn: false,
      learnOnlineData: null,
      examIndependentData: null,
      surveyIndependentData: null,
      boardCommunityData: null,
      showPopup: false,
      firstCharOfNames: localStorage.getItem("firstChar"),
      bgColorOfName: localStorage.getItem("bgColors"),
      boardName: "",
      isNoData: false,
      isNoDataRecentView: false,
      listData: [],
      baordIdentifier: "",
      boardDetail: "",
      isScroll: false,
      isSkillPath: localStorageUtil.isSkillPath(),
    };
  },

  computed: {
    // swiper define
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    reverseItems: function () {
      return this.recommendedList.slice().reverse();
    },
    ...mapState({
      memberDetail: (state) => state.member.memberDetail,
    }),
  },

  mixins: [topAppBarMixin],

  created() {
    let token = localStorage.getItem(storageConstants.token);
    let redirectPath = localStorage.getItem(storageConstants.redirectPath);
    const dynamicQuery = JSON.parse(localStorage.getItem(storageConstants.dynamicQuery));
    if (!token) {
      i18nApi
        .guestBrands()
        .then((response) => {
          this.brands = response.data.data;
          const pathName = this.brands.length < 2 ? "Login" : "BrandSelect";
          this.$router.push({ name: pathName });
        })
        .catch(() => this.$router.push("/error"));
    } else if (redirectPath) {
      this.$router.push({ name: redirectPath });
      localStorage.removeItem(storageConstants.redirectPath);
    }

    if (dynamicQuery && dynamicQuery.routerPath) {
      this.$router.push(dynamicQuery.routerPath)
    }
  },

  mounted() {
    if ($(document).height() < $(window).height()) {
      this.isScroll = true;
    }
    if (this.$route.query && this.$route.query.showPopup === "1") {
      this.showPopup = true;
    } else {
      this.showPopup = false;
    }
    pointApi
      .pointListType(params)
      .then((response) => {
        this.pointHistry = response.data.data.content;
      })
      .catch((err) => {});

    portfolioApi.portfolioList().then((response) => {
      this.portFolioList = response.data.data;
    });

    let learningParams = this.learningSetParams();
    let completionParams = this.completionSetParams();
    let examParams = this.examSetParams();

    // TODO : 병럴처리로 변환할 수 있는건 변환 예정

    //(get Ongoing micro lesson count)
    microLearnApi
      .learnCountLesson(learningParams)
      .then((response) => {
        this.microLearning = response.data.data;
      })
      .catch(() => {});

    //(get Ongoing lesson count)
    learnApi
      .learnCountLesson(learningParams)
      .then((response) => {
        this.learning = response.data.data;
      })
      .catch(() => {});

    //(get completed lesson count)
    learnApi
      .learnCountLesson(completionParams)
      .then((response) => {
        this.completion = response.data.data;
      })
      .catch(() => {});

    // 단독 시험 목록(get my Exam count)
    examApi
      .myEaxmCount(examParams)
      .then((response) => {
        this.eaxmTest = response.data.data;
      })
      .catch(() => {});

    // 나의 설문 목록(get my independent survey count)
    surveyApi
      .surveyCount()
      .then((response) => {
        this.survey = response.data.data;
      })
      .catch((err) => {});

    this.setTopAppBarHomeBlank();
    localStorage.removeItem("subjectlist");
    localStorage.removeItem("subjectId");
    localStorage.removeItem("subjectTitle");
    let params = {
      size: 5,
    };

    this.getMemberData();

    // degree notice data
    campaignApi
      .campaign({ locationType: "MAIN_PAGE" })
      .then((response) => {
        this.campaignData = response.data.data;
        if (this.campaignData) {
          this.isCompaignImage = true;
          this.compaignImage = this.campaignData.image;
          this.dynamicLinkImage = this.campaignData.dynamicLink
            ? this.campaignData.dynamicLink.shortLink
            : "";
        }
      })
      .catch((err) => {});

    // fetch all tags data
    mainApi
      .fetchPopularTag()
      .then((response) => {
        this.popularTag = response.data.data;
      })
      .catch((err) => {});
    // get ongoing data from API
    mainApi
      .fetchRecentContent(params)
      .then((response) => {
        this.recentContentData = response.data.data.content;
        if (response.data.data.content) {
          this.recentContentLength = response.data.data.totalElements;
        }
        this.linearProgress = false;
      })
      .catch((err) => {
        let responseData = err.response.data;
        this.$error({ content: responseData.errMsg }).then(() => {});
      });

    // 스킬패스 인 경우만 실행
    if (this.isSkillPath) {
      mainApi
        .fetchRecentMicroContent(params)
        .then((res) => {
          this.recentMicroContentData = res.data.data.content;
          if (res.data.data.content) {
            this.recentMicroContentDataLength = res.data.data.totalElements;
          }
          this.linearProgress = false;
        })
        .catch((err) => this.$error({ content: err.response.data.errMsg }));
    }

    // get recently view data from API
    const recentLearningApi = this.isSkillPath ? mainApi.fetchRecentMicroLearning : mainApi.fetchRecentLearning;
    recentLearningApi()
      .then((response) => {
        this.recentLearning = response.data.data;
        if (this.recentLearning.length > 0) {
          this.isNoDataRecentView = false;
        } else {
          this.isNoDataRecentView = true;
        }
      })
      .catch((err) => {
        let responseData = err.response.data;
        this.$error({ content: responseData.errMsg }).then(() => {});
      });

    let recomendParamss = {
      size: params.size,
      sort: "groupId,desc",
    };
    // get recommended data from API
    mainApi
      .fetchRecommendedList(recomendParamss)
      .then((response) => {
        this.recommendedList = response.data.data.content;
        if (response.data.data.content) {
          this.recommendedListLength = response.data.data.totalElements;
        }
      })
      .catch((err) => {
        let responseData = err.response.data;
        this.$error({ content: responseData.errMsg }).then(() => {});
      });

    mainApi
      .getBoard()
      .then((response) => {
        this.baordIdentifier = response.data.data.identifier;
        this.boardName = response.data.data.name;
        this.boardDetail = response.data.data;
        if (this.baordIdentifier) {
          let params = {
            name: "",
            subject: "",
            contents: "",
            statuses: "",
            type: "ALL",
            page: 1,
            size: 3,
            sort: "id,desc",
          };
          boardApi
            .fetchList(params, this.baordIdentifier)
            .then((response) => {
              if (response.data.data.content.length > 0) {
                this.listData = response.data.data.content;
                this.isNoData = false;
              } else {
                this.isNoData = true;
              }
            })
            .catch((err) => {
              console.log("err=>");
            });
        } else {
        }
      })
      .catch((err) => {
        console.log("GET BOARD ERROR : ", err)
        let responseData = err.response.data;
        this.$error({ content: responseData.errMsg }).then(() => {});
      });
  },
  methods: {
    //  choose tab on click event
    selectedTagFun(tag, selectedTagArr) {
      if (selectedTagArr.includes(tag.id)) {
        var selectedTagArr = selectedTagArr.filter(function (
          value,
          index,
          arr
        ) {
          return value != tag.id;
        });
      } else {
        selectedTagArr.push(tag.id);
      }
      if (selectedTagArr.length > 0) {
        this.tagSearchBtn = true;
      } else {
        this.tagSearchBtn = false;
      }
      this.selectedTags = selectedTagArr;
    },
    // concant mutilpe seach tag on click event
    serachResultByTag() {
      let tags = this.selectedTags.join(",");
      this.$router.push({ name: "TagSearch", query: { selectedtag: tags } });
    },

    // set parameter
    learningSetParams() {
      const params = {
        status: "LEARNING",
        name: "",
      };
      return params;
    },
    completionSetParams() {
      const params = {
        status: "COMPLETION",
        name: "",
      };
      return params;
    },
    examSetParams() {
      const params = {
        application: true,
      };
      return params;
    },
    // get user data from API
    getMemberData() {
      mainApi
        .fetMember()
        .then((response) => {
          this.memberData = response.data.data;
          this.firstName = this.memberData ? this.memberData.name.first : "";
          this.lastName = this.memberData ? this.memberData.name.last : "";
          this.fullName = this.memberData ? this.memberData.name.fullName : "";
          this.profileImage = this.memberData ? this.memberData.profile : "";
        })
        .catch((err) => {
          let responseData = err.response.data.meta;
          this.$error({ content: responseData.errMsg }).then(() => {});
        });
    },
    // Move to learning deatil
    redirectToLearnDetail(id, type) {
      localStorage.setItem("learnDetails", "backtoMain");
      this.$router.push(
        type === "MICRO"
          ? `/micro/${id}?status=LEARNING`
          : `/learn/${id}?status=LEARNING`
      );
    },
    // Move to course detail
    redirectToCourseDetail(id) {
      this.$router.push("/degree/" + id + "?type=ListNew");
    },
    // Move to learning detail
    redirectToRecentLearnDetail(id) {
      localStorage.setItem("learnDetails", "backtoMain");
      this.$router.push(this.isSkillPath ? `/micro/${id}` : `/learn/${id}`);
    },
    // Move to micro learning list
    goToMicroLearning() {
      localStorage.setItem("learning", "myinformation");
      this.$router.push({
        name: "MicroDegreeList",
        query: { status: "LEARNING" },
      });
    },
    // Move to learning list
    goToLearning() {
      localStorage.setItem("learning", "myinformation");
      this.$router.push({ name: "LearnList", query: { status: "LEARNING" } });
    },
    // Move to learning completion list
    goToCompletion() {
      localStorage.setItem("learning", "myinformation");
      this.$router.push({ name: "LearnList", query: { status: "COMPLETION" } });
    },
    // Move to independent exam list
    goToMyTest() {
      localStorage.setItem("mytest", "myinformation");
      this.$router.push({ name: "IndependentExam", query: { listType: "my" } });
    },
    // Move to independent survey list
    goToMySurvey() {
      localStorage.setItem("mysurvey", "myinformation");
      this.$router.push({
        name: "IndependentSurvey",
        query: { listType: "my" },
      });
    },
    // Move to community list
    moveToBoardList(boardList) {
      this.$router.push(
        "/board/" +
          boardList.identifier +
          "?boardName=" +
          encodeURI(boardList.name.replace("&", "-")) +
          "&categoryName=" +
          encodeURI(boardList.boardCategory.name)
      );
    },
    // Move to community detail
    moveToDetail(postId) {
      this.$router.push({
        name: "BoardView",
        params: { boardId: this.baordIdentifier, postId: postId },
        query: {
          boardName: this.boardName,
          categoryName: this.boardDetail.category,
          fromPage: "main",
        },
      });
    },
  },
};
</script>

<style type="text/css" scoped >
.mwc-linear-progress {
  --mdc-theme-primary: red;
  --mdc-linear-progress-buffer-color: orange;
  /* Note: all that was changed from default was "fill='orange'" */
  --mdc-linear-progress-buffering-dots-image: url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' enable-background='new 0 0 5 2' xml:space='preserve' viewBox='0 0 5 2' preserveAspectRatio='none slice'%3E%3Ccircle cx='1' cy='1' r='1' fill='orange'/%3E%3C/svg%3E");
}
.header-info {
  box-shadow: 0px 5px 40px var(--Shadow2);
}

.header-info-image {
  overflow: hidden;
  border-radius: 50%;
  border: 9px solid var(--SecondaryBtn);
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translate(0, -50%);
}
.header-info-image img {
  width: 62px;
  height: 62px;
  object-fit: cover;
}

.header-info-image1 {
  border-radius: 50%;
  border: 9px solid var(--DocumentWhite);
  position: absolute;
  left: 16px;
  top: 64%;
  transform: translate(0, -50%);
}
.header-info-image1 img {
  width: 62px;
  height: 62px;
  object-fit: cover;
}
.header-info-image1 img {
  border-radius: 50%;
  box-shadow: 0 10px 16px 0 var(--Shadow2);
}

.header-info1 {
  box-shadow: 3px 15px 20px 0 var(--Shadow2);
}

.headerText {
  margin-left: 96px;
  font-size: 22px;
}

/* .titleStrip p:first-child {
	font-size: 20px;
} */

.titleStrip p:nth-child(2) {
  font-size: 14px;
  color: var(--Mainbtn);
}

.navImgStrip {
  overflow-x: auto;
}

.navImgStrip a:last-child {
  margin-right: 16px;
}

.navImgStrip a img {
  min-width: 60px;
  max-width: 60px;
}

span.swiperImageIndicator {
  right: 8px;
  bottom: 8px;
  font-size: 12px;
  background: var(--Shadow2);
  border-radius: 30px;
}
.swiperSlideWrapper {
  width: 70%;
}
.swiperPercentWrapper {
  line-height: 0.5;
}
.swiperImageHolder img {
  max-height: 130px;
  object-fit: cover;
}
.swiperTitle {
  font-size: 16px;
}
.swiperSubTitle {
  font-size: 14px;
}
.cardInner {
  border-bottom: 1px solid var(--Divider);
}
.cardInner:last-child {
  border-bottom: none;
}
.swiper-slide {
  width: 232px;
}
.leaf-wrapper {
  position: absolute;
  left: 60px;
  top: -22px;
}
@media (min-width: 768px) {
  .bubble-image {
    width: 300px;
  }

  .swiperSlideWrapper {
    width: 350px;
  }
  .swiper-slide {
    width: auto;
  }
  .swiperImageHolder img {
    min-height: 235px;
    object-fit: cover;
  }
}

@media (max-width: 420px) {
  .headerText {
    font-size: 18px;
  }
}
@media (max-width: 320px) {
  .headerText {
    font-size: 15px;
  }
}
.navImgStrip > div:last-child {
  padding-right: 15px;
}

.home-progressbar {
  position: absolute;
  height: 2px;
  background: var(--Saleline);
  bottom: 0;
}
.swiper-button-next {
  right: 2px !important;
}
.swiper-button-prev {
  left: 2px !important;
}
.main-swiper {
  padding-bottom: 80px;
  margin-bottom: 50px;
}
</style>
